<template>
    <div>
        <v-data-table :key="updateTable" :items="value" v-if="value" :headers="tableHeaders" :items-per-page="-1" hide-default-footer>
            <template v-slot:item.taskType="{item, index}">
                <eod-object-autocomplete :value="item.taskType" :fields="['id','name','templates{type id name content}']" endpoint="taskTypes" return-object @input="val => updateWorkflow(index, val)"></eod-object-autocomplete>
            </template>
            <template v-slot:item.productType="{item, index}">
                <eod-object-autocomplete :value="item.productType" :fields="['id','name']" endpoint="productTypes" return-object @input="val => updateProductType(index, val)"></eod-object-autocomplete>
            </template>
            <template v-slot:item.jobType="{item, index}">
                <eod-object-autocomplete v-if="item.taskType || item.productType" :value="item.jobType" return-object endpoint="jobTypes" @input="val => updateJobType(index, val)"></eod-object-autocomplete>
            </template>
            <template v-slot:item.variant="{item, index}">
                <eod-autocomplete v-if="item.jobType && jobTypeTemplates[item.jobType.id] && jobTypeTemplates[item.jobType.id].content.variants && jobTypeTemplates[item.jobType.id].content.variants[0]" :items="jobTypeTemplates[item.jobType.id].content.variants" :value="item.variant" @input="val => updateVariant(index, val)"></eod-autocomplete>
            </template>
            <template v-slot:item.actions="{item, index}">
                <eod-btn @click="removeConfiguration(index)" icon color="error"><v-icon small>mdi-trash-can-outline</v-icon></eod-btn>
            </template>
        </v-data-table>
        <div class="d-flex">
        <eod-btn class="ml-auto" @click="addConfiguration"><v-icon small left>mdi-plus</v-icon>Configuratie toevoegen</eod-btn>
        </div>
    </div>
</template>
<script>
    import eodObjectAutocomplete from './eod-object-autocomplete.vue';
    export default {
        name: 'eod-workflow-config',
        components: {
            eodObjectAutocomplete
        },
        props: {
            value: Array,
            taskType: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            updateTable: 73972,
            jobTypeTemplates: {},
            tableHeaders: [{value:'jobType', text:'Jobtype', width:'33.33%'},{value:'variant', text:'Variant', width:'33.33%'}, {value:'actions', text:''}]
        }),
        async created(){
            if(this.taskType){
                this.tableHeaders = [{value:'productType', text:'Asset type', width:'33.33%'}].concat(this.tableHeaders);
            } else {
                this.tableHeaders = [{value:'taskType', text:'Workflow', width:'33.33%'}].concat(this.tableHeaders);
            }

            if(this.value){
                const jobTypeIds = [];
                for (let i = 0; i < this.value.length; i++) {
                    const config = this.value[i];
                    if(config.jobType && config.jobType.id && !jobTypeIds.includes(config.jobType.id)){
                        jobTypeIds.push(config.jobType.id);
                    }
                }

                await this.loadJobTypeTemplates(jobTypeIds);
            }
        },
        methods:{
            removeConfiguration(index){
                const val = this.value;
                val.splice(index, 1);
                this.$emit('input', val);
            },
            updateProductType(index, value){
                const val = this.value;

                if(value && val[index].productType && val[index].productType.id == value.id){
                    return;
                }

                val[index].productType = value;

                val[index].jobType = this.getWorkflowJobType(this.taskType);
                val[index].variant = null;
                this.$emit('input', val);

                this.$nextTick(() => {
                    this.updateTable++;
                });
            },
            getWorkflowJobType(workflow){
                const workflowTemplates = workflow.templates.filter(item => item.type == 'WORKFLOW');

                if(!workflowTemplates[0]){
                    return;
                }

                const workflowTemplate = workflowTemplates[0];
                for (let pageIndex = 0; pageIndex < workflowTemplate.content.pages.length; pageIndex++) {
                    const page = workflowTemplate.content.pages[pageIndex];
                    for (let cellIndex = 0; cellIndex < page.cells.length; cellIndex++) {
                        const cell = page.cells[cellIndex];
                        if(cell.typeId == 'form'){
                            if(cell.settings && cell.settings.type == 'fixed' && cell.settings.jobTypeId){
                                return {id: cell.settings.jobTypeId};
                            }

                            break;
                        }
                    }
                }

                return null;
            },
            updateWorkflow(index, value){
                const val = this.value;

                if(value && val[index].taskType && val[index].taskType.id == value.id){
                    return;
                }

                val[index].taskType = value;

                val[index].jobType = this.getWorkflowJobType(value);
                val[index].variant = null;
                this.$emit('input', val);
                
                this.$nextTick(() => {
                    this.updateTable++;
                });
            },
            async loadJobTypeTemplates(jobTypeIds){
                return new Promise((resolve, reject) => {
                    for (let i = 0; i < jobTypeIds.length; i++) {
                        const id = jobTypeIds[i];
                        if(this.jobTypeTemplates[jobTypeIds[i]]){
                            jobTypeIds.splice(i, 1);
                        }
                    }

                    if(jobTypeIds[0]){
                        this.$eod.get('templates', ['id','name','content', 'jobTypes{id}'], {
                            whereInRelated:[
                                {
                                    column:'job_type_id',
                                    relation: 'jobTypes_templates',
                                    array: jobTypeIds
                                }
                            ],
                            where: [
                                {
                                    column: 'type',
                                    value: 'FORM'
                                },
                            ]
                        }).then(response => {
                            if(response && response.data && response.data.data && response.data.data.templates){
                                for (let i = 0; i < response.data.data.templates.edges.length; i++) {
                                    const template = response.data.data.templates.edges[i];
                                    for (let j = 0; j < template.jobTypes.length; j++) {
                                        const jobType = template.jobTypes[j];
                                        this.jobTypeTemplates[jobType.id] = template;
                                    }
                                }
                                resolve();
                            }

                            resolve();
                        }).catch(e => {
                            reject(e);
                        });
                    } else {
                        resolve();
                    }
                });
            },
            async updateJobType(index, value){
                const val = this.value;

                val[index].jobType = value; 
                
                if(value && val[index].jobType && val[index].jobType.id != value.id){
                    val[index].variant = null;
                    this.$emit('input', val);
                }

                if(!value){
                    return;
                }

                this.loadJobTypeTemplates([value.id]);

                this.$forceUpdate();
            },
            updateVariant(index, value){
                const val = this.value;
                val[index].variant = value;

                this.$emit('input', val);
            },
            addConfiguration(){
                let val = this.value;
                if(!val){
                    val = [];
                }

                const newRow = {
                    jobType:null,
                    variant:null,
                }

                if(this.taskType){
                    newRow.productType = null;
                } else {
                    newRow.taskType = null;
                }

                val.push(newRow);

                this.$emit('input', val);
            }
        }

    }
</script>